import { ErrorText } from "../typography/errorText";

export const RangeRadioInput = ({
  title,
  titleClassName = "",
  options = [],
  setValue,
  value,
  errors,
}: {
  title: string;
  titleClassName?: string;
  options: {
    text: string;
    value: object | number | string;
  }[];
  value: object | number | string;
  setValue: (val: object | number | string) => void;
  errors?: string;
}) => {
  return (
    <div className="flex flex-col gap-3">
      <p
        className={`${titleClassName} text-sm font-medium text-pry-dark-green-300`}
      >
        {title}
      </p>

      <div className="flex flex-wrap gap-2">
        {options.map((option, idx) => {
          const key = `option-${idx}`;

          return (
            <button
              type="button"
              className={`
                text-xs text-pry-dark-green-300/50
                p-[4px] min-w-[58px] text-center
                border border-transparent rounded-[4px]
                bg-light-green-bg
                hover:cursor-pointer hover:scale-95
                focus:scale-95
                ${
                  JSON.stringify(value) === JSON.stringify(option.value) &&
                  `!text-pry-green-200 font-semibold
                  scale-95
                  !border-pry-green-200
                  `
                }
                transition-all
                `}
              key={key}
              onClick={() => {
                setValue(option.value);
              }}
            >
              {option.text}
            </button>
          );
        })}
      </div>

      {errors && <ErrorText text={errors} />}
    </div>
  );
};
